import { log } from "@tumbodash/browserPackages";
import initSocketIo from "./socket/init.js";

// Generate JSDOCS here! 

/**
 * @async
 * @description Initialize the game engine
 * @return {null}
 */
async function init() {

	await initSocketIo();

	log.session("Game Engine Initialized");

	return null;
}

export default init;
